module.exports = __webpack_public_path__ + "static/fighter_sparring-e2d6e20006b98e79315fe10c28e3c500.png";